import React from "react";

function FamilyGroupRow({ familyGroup, onEdit, onDelete, organizationsParent }) {
  // Encontrar el nombre de la organización
  const organization = organizationsParent?.find(
    (org) => org._id.toString() === familyGroup.organizationId?.toString()
  );
  const organizationName = organization ? organization.name : "-";

  return (
    <tr className="border-b">
      <td className="px-4 py-2">{familyGroup.nombre}</td>
      <td className="px-4 py-2">{organizationName}</td>
      <td className="px-4 py-2">
        {familyGroup.createdAt
          ? new Date(familyGroup.createdAt).toISOString().replace("T", " ").slice(0, -5)
          : "-"}
      </td>
      <td className="px-4 py-2">
        {familyGroup.isActive ? (
          <span className="px-2 py-1 bg-green-200 text-green-800 rounded-full text-xs">Activa</span>
        ) : (
          <span className="px-2 py-1 bg-red-200 text-red-800 rounded-full text-xs">Inactiva</span>
        )}
      </td>
      <td className="px-4 py-2">
        <button onClick={() => onEdit(familyGroup)} className="mr-2">
          <img
            src={`${process.env.PUBLIC_URL}/svg/editIco.svg`}
            alt="Editar"
            className="h-5 w-5 hover:scale-150 transition-transform"
          />
        </button>
        <button onClick={() => onDelete(familyGroup)}>
          <img
            src={`${process.env.PUBLIC_URL}/svg/deleteIco.svg`}
            alt="Eliminar"
            className="h-5 w-5 hover:scale-150 transition-transform"
          />
        </button>
      </td>
    </tr>
  );
}

export default FamilyGroupRow;
